var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplore2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 376,
    viewBox: "0 0 358 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.841 353.178L278.298 329.319L297.834 324.469L300.272 300.628L319.811 295.759L322.265 271.919L341.804 267.05",
    stroke: "#D3B714",
    strokeWidth: 2.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.745 367.37L291.201 343.512L310.737 338.662L313.176 314.82L332.715 309.952L335.169 286.111L354.707 281.243",
    stroke: "#D3B714",
    strokeWidth: 2.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M321.716 356.451L338.447 365.885L339.517 351.732L321.716 356.451Z",
    stroke: "#037B0B",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M340.22 256.983C345.143 256.983 349.134 252.992 349.134 248.069C349.134 243.146 345.143 239.155 340.22 239.155C335.297 239.155 331.306 243.146 331.306 248.069C331.306 252.992 335.297 256.983 340.22 256.983Z",
    stroke: "#D3B714",
    strokeWidth: 2.31,
    strokeDasharray: "3 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.192 343.64L242.976 312.515L267.262 302.47L268.046 271.344L292.339 261.275L293.098 230.169L317.392 220.1M253.953 354.182L254.736 323.057L279.011 312.983L279.795 281.858L304.082 271.813L304.865 240.688L329.159 230.618",
    stroke: "#06BBC7",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.894 322.078L209.678 290.953L233.965 280.908L234.748 249.782L259.042 239.713L259.801 208.607L284.094 198.538M220.655 332.62L221.439 301.495L245.714 291.421L246.497 260.296L270.784 250.251L271.568 219.126L295.861 209.056",
    stroke: "#E73635",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore2);
export default __webpack_public_path__ + "static/media/explore2.1b1c8fece8e250687916586b55d8e334.svg";
export { ForwardRef as ReactComponent };